import script from "./CopyElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyElement.vue?vue&type=script&setup=true&lang=ts"

import "./CopyElement.vue?vue&type=style&index=0&id=7c023cc3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c023cc3"]])

export default __exports__